@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import cz.bohouskovi.svatba.components.layouts.PageLayout as _cz_bohouskovi_svatba_components_layouts_PageLayout
import cz.bohouskovi.svatba.pages.HomePage as _cz_bohouskovi_svatba_pages_HomePage
import cz.bohouskovi.svatba.pages.RsvpPage as _cz_bohouskovi_svatba_pages_RsvpPage
import cz.bohouskovi.svatba.pages.SvatbaPage as _cz_bohouskovi_svatba_pages_SvatbaPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Svatební web"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "cz.bohouskovi.svatba.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _cz_bohouskovi_svatba_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "cz.bohouskovi.svatba.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                cz.bohouskovi.svatba.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _cz_bohouskovi_svatba_pages_HomePage()
        }
        ctx.router.register(
            "/rsvp",
            layoutId = "cz.bohouskovi.svatba.components.layouts.PageLayout",
        ) { pageCtx -> 
            _cz_bohouskovi_svatba_pages_RsvpPage()
        }
        ctx.router.register(
            "/svatba",
        ) { pageCtx -> 
            _cz_bohouskovi_svatba_pages_SvatbaPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("foot-note-text", cz.bohouskovi.svatba.FootNoteTextStyle)
        ctx.theme.registerStyle("subheadline-text", cz.bohouskovi.svatba.SubheadlineTextStyle)
        ctx.theme.registerStyle("page-content", cz.bohouskovi.svatba.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("nav-header", cz.bohouskovi.svatba.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("decoration-image", cz.bohouskovi.svatba.components.sections.DecorationImageStyle)
        ctx.theme.registerStyle("footer", cz.bohouskovi.svatba.components.sections.FooterStyle)
        ctx.theme.registerVariant("-circle", cz.bohouskovi.svatba.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", cz.bohouskovi.svatba.UncoloredButtonVariant)
        ctx.theme.registerKeyframes("scroll-arrow-bounce", cz.bohouskovi.svatba.components.sections.ScrollArrowBounceAnim)
        ctx.theme.registerKeyframes("side-menu-slide-in", cz.bohouskovi.svatba.components.sections.SideMenuSlideInAnim)
        cz.bohouskovi.svatba.initStyles(ctx)
        cz.bohouskovi.svatba.initSiteStyles(ctx)
        cz.bohouskovi.svatba.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        cz.bohouskovi.svatba.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
